/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Laster inn...',
	'dlg_close': 'Lukk',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Avbryt',
	'dlg_back': 'Gå tilbake',
	'dlg_done': 'Ferdig',
	'dlg_save': 'Lagre',

	// Slider
	'sliderRegionLabel': 'Glidebryterkontroll, bruk høyre- og venstrepilene til å flytte glidebryterhåndtakene',
	'sliderHandleLabel': 'Glidebryterhåndtak',
	'a11ySliderHandleLabel': 'Glidebryterhåndtak %{sliderValue}',
	'sliderInputLabel': 'verdi',

	// Side bar
	'sidebarAdd': 'Legg til',
	'clearTextFilterValue': 'Fjern',
	'missingDataSetData': 'Dataene for dette datasettet er ikke tilgjengelige. Oppdater datasettet eller kontakt administratoren for å få tilgang til kilden.',

	// Toolbar
	'toolbarRegionLabel': 'Verktøylinje',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Fontfamilie',
	'fontFamilyStyle': 'Fontstil',
	'regularFontStyle': 'Normal',
	'fontSizeSelect': 'Fontstørrelse',
	'fontColorSelect': 'Farge',
	'fontStyle': 'Stil',
	'colorPickerTitle': 'Velge en farge',
	'bold': 'Fet',
	'italic': 'Kursiv',
	'underline': 'Understrek',
	'fontAlignment': 'Justering',
	'justifyLeft': 'Venstrejuster',
	'justifyCenter': 'Midtstill',
	'justifyRight': 'Høyrejuster',
	'insertOrderedList': 'Sortert liste',
	'insertUnorderedList': 'Usortert liste',
	'fontColorPicker': 'Fargevelger',
	'textWrap': 'Bryt tekst',
	'restore': 'Bruk standardverdier',
	'textAutoFontSize': 'Automatisk',
	'textDefaultFontSize': 'Standard',
	'textItemTitle': 'Tittel',
	'textLabelShadow': 'Etikettskygge',
	'textContrastLabelColor':'Kontrastfarge',
	'toggleOn': 'På',
	'toggleOff': 'Av',
	'contrastLabelColorInfo': 'Automatisk justering av etikettfarge for tilgjengelighet. Dette overstyrer fontfargen.',
	'labelShadowInfo':'Legg til skygge på tekst for tilgjengelighet.',
	'applyToAll':'Bruk stil på alle akser',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Antall resultater (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Prosent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Øverste eller nederste alternativ',
	'topbottomOptionLabel': 'Vis',
	'searchByLabel': 'Etter',
	'searchNoMatches': 'Ingen samsvar funnet',
	'topbottomRankColumnLabel': 'Legg til en rangeringskolonne i tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Øverste antall',
	'topPercent': 'Øverste %',
	'bottomCount': 'Nederste antall',
	'bottomPercent': 'Nederste %',
	'searchColumn': 'Finn en kolonne',
	'searchColumnAriaLabel': 'Finn en kolonne. Skriv navnet på kolonnen du vil søke etter, og bruk deretter pil ned for å finne kolonnen på en liste',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rangering (%{columnLabel})',
	'topbottomClearLabel': 'Tilbakestill',

	// Format
	'formatAuto': 'Automatisk',
	'formatConvertPercent': 'Konverter desimal til prosentverdi',
	'formatAbbreviate': 'Forkort',
	'formatUseGrouping': 'Bruk tusenskilletegn',
	'dateStyle': 'Datostil',
	'dateTimeStyle': 'Dato/klokkeslett-stil',
	'formatMissingValueCharactersInfo': 'Tegn for manglende verdi angir tegnene som skal vises når verdien mangler.',
	'currencySymbolLabel': 'Valutasymbol',
	'customSymbolPlaceholder': 'Legg til et symbol',
	'customSymbolLabelInfo': 'Oppgir ett eller flere tegn som skal brukes som et tilpasset symbol. Dette symbolet står foran tallet og et hvilket som helst tegn.',
	'numberLabel': 'Talletikett',
	'numberPositionLabel': 'Etikettposisjon',
	'negativeSignPosition': 'Posisjon for negativt tegn',
	'negativeSign': 'Symbol for negativt tegn',
	'numberLabelInfo': 'Oppgir en etikett for det formaterte tallet og plasseres som et prefiks eller suffiks avhengig av etikettposisjonen.',
	'nullValueDefault': '<standard>',
	'nullValueContent': '(ingen verdi)',
	'default': 'Standard',
	'beginning': 'Begynnelse',
	'end': 'Slutt',
	'formatLabel': 'Velg et format',

	// More data indicator
	'moreDataIndicator': 'Dataene dine ble kuttet ved %{threshold} elementer. Bruk et filter for å vise færre.',

	// Expanded View / Focus mode
	'evCollapse': 'Komprimer',
	'duplicate': 'Dupliser',
	'copyOf': 'Kopi av %{name}',
	'unableToDuplicateBoard': 'Kan ikke duplisere "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Kan ikke laste inn objektene.',

	// Custom widgets
	'customWidget': 'Tilpasset widget',

	// Auto group
	'group': 'Gruppe',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hårstrek',
	'textFontFamilySubClassThin': 'Tynn',
	'textFontFamilySubClassThinItalic': 'Tynn kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra lett',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra lett kursiv',
	'textFontFamilySubClassLight': 'Lett',
	'textFontFamilySubClassLightItalic': 'Lett kursiv',
	'textFontFamilySubClassRegular': 'Vanlig',
	'textFontFamilySubClassRegularItalic': 'Vanlig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Middels',
	'textFontFamilySubClassMediumItalic': 'Middels kursiv',
	'textFontFamilySubClassHeavy': 'Tung',
	'textFontFamilySubClassHeavyItalic': 'Tung kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfet',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassBold': 'Fet',
	'textFontFamilySubClassBoldItalic': 'Fet kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fet',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Sjablong',
	// END: Remove FontFamilySubClass
});
